var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.212128 3.59274C0.212128 3.11046 0.603091 2.7195 1.08537 2.7195H8.50792C11.6789 2.7195 14.184 5.39549 14.184 8.61387C14.184 11.8323 11.6789 14.5083 8.50792 14.5083H5.51822C5.24208 14.5083 5.01822 14.2844 5.01822 14.0083V13.2618C5.01822 12.9856 5.24208 12.7618 5.51822 12.7618H8.50792C10.642 12.7618 12.4375 10.9417 12.4375 8.61387C12.4375 6.28607 10.642 4.46598 8.50792 4.46598H1.08537C0.603091 4.46598 0.212128 4.07502 0.212128 3.59274Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14962 0.881396C4.34489 1.07666 4.34489 1.39324 4.14962 1.5885L2.10819 3.62994L4.14962 5.67137C4.34489 5.86663 4.34489 6.18321 4.14962 6.37848L3.62178 6.90632C3.42652 7.10158 3.10994 7.10158 2.91467 6.90632L0.255766 4.24741C-0.0852554 3.90639 -0.0852554 3.35348 0.255766 3.01246L2.91467 0.353553C3.10994 0.158291 3.42652 0.158291 3.62178 0.353553L4.14962 0.881396Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/Undo.0edd72109473f1226a2c2ea66891c28b.svg";
export { ForwardRef as ReactComponent };